import * as types from '../constants/ActionTypes-privilegeParty';


export const setPrivilegePartys = itemsParty => ({
  type: types.SET_ELEMENT_PARTY,
  payload: itemsParty,
  reducer_type: 'reducer_privilege'
});
  
